// extracted by mini-css-extract-plugin
export default {"card":"WelcomeForm_card__D9R34"};